import { CIcon } from '~/icons/types'

export const ciBold: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18.889 12.111a5.55 5.55 0 0 0-.706-.58C19.021 10.54 19.5 9.312 19.5 8c0-1.468-.572-2.85-1.611-3.889A5.464 5.464 0 0 0 14 2.5H6A1.5 1.5 0 0 0 4.5 4v16A1.5 1.5 0 0 0 6 21.5h9c1.469 0 2.85-.572 3.889-1.611A5.464 5.464 0 0 0 20.5 16c0-1.469-.572-2.85-1.611-3.889ZM7.5 5.5H14a2.52 2.52 0 0 1 1.768.732c.471.473.732 1.101.732 1.768s-.261 1.295-.732 1.768A2.52 2.52 0 0 1 14 10.5H7.5v-5Zm9.268 12.268A2.522 2.522 0 0 1 15 18.5H7.5v-5H15c.657 0 1.302.267 1.768.732.466.465.732 1.111.732 1.768s-.267 1.302-.732 1.768Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bold',
  type: 'solid'
}
